import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Style from '../style';
import AnalysisWidget from '../../widget';
import Overview from '../../amp-widgets/overview';
import MeetPeople from '../../amp-widgets/meet-people';
import KeyIndicators from '../../amp-widgets/key-indicators';
import PreInvestment from '../../amp-widgets/pre-investement';
import EsgPerformance from '../../amp-widgets/esg-performance';
import ImpactPriorities from '../../amp-widgets/impact-priorities';
import RepaymentOverview from '../../amp-widgets/repayment-overview';
import MercuryUseOverview from '../../amp-widgets/mercury-use-overview';
import ProductionDataValue from '../../amp-widgets/production-data-value';
import ContinuousImprovement from '../../amp-widgets/continuous-improvement';
import RepaymentMonthlyProgress from '../../amp-widgets/repayment-monthly-progress';
import MercuryUseMonthlyTracking from '../../amp-widgets/mercury-use-monthly-tracking';

const productionData = [
  { date: 'M01', Score: 0, key: 1 },
  { date: 'M02', Score: 0, key: 2 },
  { date: 'M03', Score: 0, key: 3 },
  { date: 'M04', Score: 0, key: 4 },
  { date: 'M05', Score: 0, key: 5 },
  { date: 'M06', Score: 0, key: 6 },
  { date: 'M07', Score: 0, key: 7 },
  { date: 'M08', Score: 0, key: 8 },
  { date: 'M09', Score: 0, key: 9 },
  { date: 'M10', Score: 0, key: 10 },
  { date: 'M11', Score: 0, key: 11 },
  { date: 'M12', Score: 0, key: 12 },
];

export default function AMPLayout({
  id,
  data = null,
  other = {},
  redirectToView = () => { },
  getOption = () => { },
}) {
  const { t } = useTranslation();


  if (data) {
    return (
      <div>
        <Style>
          <div className="sections-cont mt-6">
            <section>
              <MeetPeople
                title={data.subjectDetails.subjectName}
                data={data.meetPeople}
                overview={data.overview}
              />
            </section>

            <section>
              <Overview data={data.overview} />
            </section>

            <section>
              <KeyIndicators data={data.keyIndicators} />
            </section>

            <AnalysisWidget
              className="with-border-header"
              title={t('Mine performance')}>
              <section>
                <PreInvestment />
                <ContinuousImprovement />
              </section>
            </AnalysisWidget>

            <section>
              <ImpactPriorities />
            </section>

            <AnalysisWidget
              className="with-border-header"
              title={t('Repayment Data')}
              tooltip={t('Repayment Data')}>
              <section>
                <RepaymentOverview />
                <RepaymentMonthlyProgress />
              </section>
            </AnalysisWidget>

            <ProductionDataValue data={productionData} />

            <section>
              <EsgPerformance />
            </section>

            <AnalysisWidget
              className="with-border-header"
              title={t('Mercury Use Tracking')}>
              <section>
                <MercuryUseOverview />
                <MercuryUseMonthlyTracking />
              </section>
            </AnalysisWidget>
          </div>
        </Style>
      </div>
    );
  }

  return null;
}
